module.exports = __webpack_public_path__ + "img/D0004.230ed9ad.svg";